/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import chroma from 'chroma-js';
import { ColorStop } from '../../components/color_picker/color_stops';

export const getSteppedGradient = function (
  colors: ColorStop[],
  steps: number
) {
  const range = colors[colors.length - 1].stop - colors[0].stop;
  const offset = colors[0].stop;
  const finalStops = [...colors.map((item) => (item.stop - offset) / range)];
  const color = [...colors.map((item) => item.color)];
  return chroma.scale(color).domain(finalStops).colors(steps);
};
